import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';

export interface Props {
  loading?: boolean;
  onCancel: () => void;
}

function AreaEditFormActions(props: Props) {
  const { loading, onCancel } = props;
  const { t } = useTranslation();
  return (
    <ActionsRow
      actions={[
        <Button
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          disabled={loading}
          fullWidth
          leftIcon="close"
          onClick={onCancel}
        />,
        <Button
          buttonText={t('save-changes')}
          buttonType={ButtonTypes.primaryFilled}
          disabled={loading}
          fullWidth
          leftIcon="check"
          type="submit"
        />,
      ]}
    />
  );
}

export default AreaEditFormActions;
